import React from 'react';
import { IconS24Close24, IconS24InfoCircle24 } from '@is24/cosma-ui-icons';
import { Popover } from 'is24-corecss';
import './InfoPopOver.css';

interface InfoPopOverProps {
  content: string[] | string;
}

const InfoPopOver: React.FC<InfoPopOverProps> = ({ content }) => {
  const [isPopOverVisible, setIsPopOverVisible] = React.useState(false);

  const contentArray = Array.isArray(content) ? content : content ? [content] : [];

  return (
    <div className='grid margin-left-xs grid-align-center' style={{ position: 'relative' }}>
      <Popover
        visible={isPopOverVisible}
        arrowPosition={'center'}
        bodyPosition={'top'}
        className='custom-popover font-body-medium-regular padding-left-xxl tvs-pop-over-dark'
      >
        <ul className='popover-list'>
          <IconS24Close24
            className='info-close-button'
            width={16}
            height={16}
            data-testid='close-icon'
            onClick={() => setIsPopOverVisible(false)}
          />
          {contentArray.map((text, index) => (
            <li key={index} className='popover-item'>
              {text}
            </li>
          ))}
        </ul>
      </Popover>
      <IconS24InfoCircle24
        onClick={() => setIsPopOverVisible(!isPopOverVisible)}
        data-testid='info-icon'
        className='verification-info-icon'
        height={18}
        width={18}
        color='#676767'
      />
    </div>
  );
};

export default InfoPopOver;
